/**
 * Slim map-data API helpers (LeadViewSet.map_data).
 *
 * Map pins intentionally omit heavy fields (property, additional_notes, followups, etc.).
 * Use GET /leads/:id/ for drawer/detail — see Leads.js drawer hydrate.
 *
 * Pin fields used by client filters:
 * - territory, status, created_at (lead-date filter), notes (status sub-filters), lat/lng
 * in_other_rep_route is NOT on map-data (never was); lock UI uses detail after drawer open.
 */
import API, { MAP_DATA_TIMEOUT } from "./api";

export { MAP_DATA_TIMEOUT };

export function filterMappableLeads(list) {
  return (Array.isArray(list) ? list : []).filter(
    (lead) => lead.territory !== null && lead.territory !== undefined
  );
}

/** Full map pin payload (bbox, territory bootstrap, non-viewport load). */
export async function fetchMapPins(params = {}) {
  const res = await API.get("leads/map-data/", {
    params,
    timeout: MAP_DATA_TIMEOUT,
  });
  return filterMappableLeads(res?.data);
}

/** Lightweight created_at options for lead-date filter (viewport mode). */
export async function fetchLeadDateSourcePins() {
  const res = await API.get("leads/map-data/", {
    params: { fields: "lead_dates" },
    timeout: MAP_DATA_TIMEOUT,
  });
  return filterMappableLeads(res?.data);
}
